"use client";

// Lazy client sections for CmsRenderer.
//
// Every URL is served by the one catch-all route, and CmsRenderer is a server
// component. `next/dynamic` called from a server component doesn't create a
// client-side split point: every client component it references was
// collected into the route's entry chunks, so every page loaded the JS and CSS
// for checkout, tickets, account, search, blog and the rest (45 JS + 27 CSS
// entry files on all pages).
//
// Called from a client module, `next/dynamic` is a real lazy boundary: a
// section's chunk loads only when a page renders it (SSR still renders it and
// preloads just that chunk). CmsRenderer imports these instead.
import dynamic from "next/dynamic";

export const CityGrid = dynamic(() => import("../CityGrid/CityGrid"));
export const BlogSection = dynamic(() => import("../Blog/BlogSection"));
export const FAQSection = dynamic(() => import("../FAQSection/FAQSection"));
export const CategorySwiper = dynamic(() => import("../Category/CategorySwiper"));
export const ArtistSwiper = dynamic(() => import("../Artist/ArtistSwiper"));
export const Showcase = dynamic(() => import("../Showcase/showcase"));
export const ContestSwiper = dynamic(() => import("../Contest/ContestSwiper"));
export const OrganizerSwiper = dynamic(() => import("../Organizer/OrganizerSwiper"));
export const FeatureEvent = dynamic(() => import("../FeatureCTA/featureCta"));
export const BottomTrending = dynamic(() => import("../BottomTrending/BottomTrending"));
export const DynamicCustomCode = dynamic(() => import("./dynamicSection/DynamicCustomCode"));
export const MobileBanner = dynamic(() => import("../mobile-banner/mobilebanner"));
export const CustomBanner = dynamic(() => import("../Banner/CustomBanner"));
export const PricingComparison = dynamic(() => import("../ForOrganizers/PricingComparison"));
export const SearchPage = dynamic(() => import("../Search/SearchPage"));
export const Listing = dynamic(() => import("../Listing/Listing"));
export const AccountLayout = dynamic(() => import("../Account/AccountLayout"));
export const MyProfile = dynamic(() => import("../Account/MyProfile"));
export const MyTickets = dynamic(() => import("../Account/MyTickets"));
export const MyContests = dynamic(() => import("../Account/MyContests"));
export const BlogList = dynamic(() => import("../Blog/BlogList"));
export const TicketDetails = dynamic(() => import("../Ticket/TicketDetails"));
export const LoginLayout = dynamic(() => import("../Header/login-form/login-layout"));
